export default "__VITE_ASSET__Df2Zn_kt__"